/**
 *
 * Asynchronously loads the component for HomePage
 *
 */

import loadable from '../../utils/loadable';
import { PupilTrackingProps } from './index';

export default loadable<PupilTrackingProps>(() => import('./index'));
